// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import Address from "./address.js"
import Contact from "./contact.js"
import SchoolClass from "./school-class.js"
import StudentCouncilMembership from "./student-council-membership.js"
import Team from "./team.js"
import UniActiveCode from "./uni-active-code.js"
import UniOwnerCode from "./uni-owner-code.js"
import UniTypeThree from "./uni-type-three.js"
import UniTypeTwo from "./uni-type-two.js"
import UniUnitType from "./uni-unit-type.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "deleted_at": {
      "column": {
        "default": null,
        "name": "deleted_at",
        "null": true,
        "type": "datetime"
      },
      "name": "deleted_at",
      "selected_by_default": null,
      "translated": null
    },
    "ean_nemhandel_profile": {
      "column": {
        "default": null,
        "name": "ean_nemhandel_profile",
        "null": true,
        "type": "string"
      },
      "name": "ean_nemhandel_profile",
      "selected_by_default": null,
      "translated": null
    },
    "ean_number": {
      "column": {
        "default": null,
        "name": "ean_number",
        "null": true,
        "type": "string"
      },
      "name": "ean_number",
      "selected_by_default": null,
      "translated": null
    },
    "ean_receiver_identifier": {
      "column": {
        "default": null,
        "name": "ean_receiver_identifier",
        "null": true,
        "type": "string"
      },
      "name": "ean_receiver_identifier",
      "selected_by_default": null,
      "translated": null
    },
    "grade_from": {
      "column": {
        "default": null,
        "name": "grade_from",
        "null": true,
        "type": "integer"
      },
      "name": "grade_from",
      "selected_by_default": null,
      "translated": null
    },
    "grade_to": {
      "column": {
        "default": null,
        "name": "grade_to",
        "null": true,
        "type": "integer"
      },
      "name": "grade_to",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "name": {
      "column": {
        "default": null,
        "name": "name",
        "null": true,
        "type": "string"
      },
      "name": "name",
      "selected_by_default": null,
      "translated": null
    },
    "number_of_students": {
      "column": {
        "default": null,
        "name": "number_of_students",
        "null": true,
        "type": "integer"
      },
      "name": "number_of_students",
      "selected_by_default": null,
      "translated": null
    },
    "organization_type": {
      "column": {
        "default": "school",
        "name": "organization_type",
        "null": false,
        "type": "string"
      },
      "name": "organization_type",
      "selected_by_default": null,
      "translated": null
    },
    "school_type": {
      "column": {
        "default": null,
        "name": "school_type",
        "null": true,
        "type": "string"
      },
      "name": "school_type",
      "selected_by_default": null,
      "translated": null
    },
    "sync_name_with_uni_c": {
      "column": {
        "default": null,
        "name": "sync_name_with_uni_c",
        "null": true,
        "type": "boolean"
      },
      "name": "sync_name_with_uni_c",
      "selected_by_default": null,
      "translated": null
    },
    "vat_number": {
      "column": {
        "default": null,
        "name": "vat_number",
        "null": true,
        "type": "string"
      },
      "name": "vat_number",
      "selected_by_default": null,
      "translated": null
    },
    "nemoa_old_number_of_pupils": {
      "column": {
        "default": null,
        "name": "nemoa_old_number_of_pupils",
        "null": true,
        "type": "integer"
      },
      "name": "nemoa_old_number_of_pupils",
      "selected_by_default": null,
      "translated": null
    },
    "students_count": {
      "column": {
        "default": 0,
        "name": "students_count",
        "null": false,
        "type": "integer"
      },
      "name": "students_count",
      "selected_by_default": null,
      "translated": null
    },
    "teams_count": {
      "column": {
        "default": 0,
        "name": "teams_count",
        "null": false,
        "type": "integer"
      },
      "name": "teams_count",
      "selected_by_default": null,
      "translated": null
    },
    "team_surveys_count": {
      "column": {
        "default": 0,
        "name": "team_surveys_count",
        "null": false,
        "type": "integer"
      },
      "name": "team_surveys_count",
      "selected_by_default": null,
      "translated": null
    },
    "uni_c_active_code": {
      "column": {
        "default": null,
        "name": "uni_c_active_code",
        "null": true,
        "type": "integer"
      },
      "name": "uni_c_active_code",
      "selected_by_default": null,
      "translated": null
    },
    "uni_c_overall_institutional_code": {
      "column": {
        "default": null,
        "name": "uni_c_overall_institutional_code",
        "null": true,
        "type": "string"
      },
      "name": "uni_c_overall_institutional_code",
      "selected_by_default": null,
      "translated": null
    },
    "uni_c_unit_type": {
      "column": {
        "default": null,
        "name": "uni_c_unit_type",
        "null": true,
        "type": "integer"
      },
      "name": "uni_c_unit_type",
      "selected_by_default": null,
      "translated": null
    },
    "uni_c_institution_type_number2": {
      "column": {
        "default": null,
        "name": "uni_c_institution_type_number2",
        "null": true,
        "type": "integer"
      },
      "name": "uni_c_institution_type_number2",
      "selected_by_default": null,
      "translated": null
    },
    "uni_c_institution_type_number3": {
      "column": {
        "default": null,
        "name": "uni_c_institution_type_number3",
        "null": true,
        "type": "integer"
      },
      "name": "uni_c_institution_type_number3",
      "selected_by_default": null,
      "translated": null
    },
    "uni_c_institution_leader": {
      "column": {
        "default": null,
        "name": "uni_c_institution_leader",
        "null": true,
        "type": "string"
      },
      "name": "uni_c_institution_leader",
      "selected_by_default": null,
      "translated": null
    },
    "uni_c_vat_number": {
      "column": {
        "default": null,
        "name": "uni_c_vat_number",
        "null": true,
        "type": "string"
      },
      "name": "uni_c_vat_number",
      "selected_by_default": null,
      "translated": null
    },
    "uni_c_p_number": {
      "column": {
        "default": null,
        "name": "uni_c_p_number",
        "null": true,
        "type": "string"
      },
      "name": "uni_c_p_number",
      "selected_by_default": null,
      "translated": null
    },
    "uni_c_owner_number": {
      "column": {
        "default": null,
        "name": "uni_c_owner_number",
        "null": true,
        "type": "integer"
      },
      "name": "uni_c_owner_number",
      "selected_by_default": null,
      "translated": null
    },
    "uni_c_latitude": {
      "column": {
        "default": null,
        "name": "uni_c_latitude",
        "null": true,
        "type": "float"
      },
      "name": "uni_c_latitude",
      "selected_by_default": null,
      "translated": null
    },
    "uni_c_longitude": {
      "column": {
        "default": null,
        "name": "uni_c_longitude",
        "null": true,
        "type": "float"
      },
      "name": "uni_c_longitude",
      "selected_by_default": null,
      "translated": null
    },
    "uni_id": {
      "column": {
        "default": null,
        "name": "uni_id",
        "null": true,
        "type": "string"
      },
      "name": "uni_id",
      "selected_by_default": null,
      "translated": null
    },
    "translated_organization_type": {
      "column": null,
      "name": "translated_organization_type",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "Organization",
  "collectionKey": "organizations",
  "collectionName": "organizations",
  "i18nKey": "organization",
  "camelizedLower": "organization",
  "name": "Organization",
  "nameDasherized": "organization",
  "pluralName": "organizations",
  "ransackable_associations": [
    {
      "className": "Organization",
      "collectionName": "organizations",
      "foreignKey": "organization_id",
      "name": "commune",
      "macro": "has_one",
      "resource_name": "Organization",
      "through": "commune_contact"
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "parent_id",
      "name": "commune_contact",
      "macro": "has_one",
      "resource_name": "Contact",
      "through": "contact"
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "child_id",
      "name": "commune_contact_for",
      "macro": "has_many",
      "resource_name": "Contact",
      "through": "contact"
    },
    {
      "className": "Organization",
      "collectionName": "organizations",
      "foreignKey": "organization_id",
      "name": "commune_for",
      "macro": "has_many",
      "resource_name": "Organization",
      "through": "commune_contact_for"
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "organization_id",
      "name": "contact",
      "macro": "has_one",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "SchoolYear",
      "collectionName": "school_years",
      "foreignKey": "school_id",
      "name": "current_school_years",
      "macro": "has_many",
      "resource_name": "SchoolYear",
      "through": null
    },
    {
      "className": "HighscoreCommune",
      "collectionName": "highscore_communes",
      "foreignKey": "commune_id",
      "name": "highscore_communes",
      "macro": "has_many",
      "resource_name": "HighscoreCommune",
      "through": null
    },
    {
      "className": "HighscoreOrganization",
      "collectionName": "highscore_organizations",
      "foreignKey": "organization_id",
      "name": "highscore_organizations",
      "macro": "has_many",
      "resource_name": "HighscoreOrganization",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "OrganizationPupilCount",
      "collectionName": null,
      "foreignKey": "organization_id",
      "name": "organization_pupil_counts",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "OrganizationUserRelationship",
      "collectionName": null,
      "foreignKey": "organization_id",
      "name": "organization_user_relationships",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "Address",
      "collectionName": "addresses",
      "foreignKey": "address_id",
      "name": "primary_address",
      "macro": "has_one",
      "resource_name": "Address",
      "through": "contact"
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "parent_id",
      "name": "region",
      "macro": "has_one",
      "resource_name": "Contact",
      "through": "contact"
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "school_id",
      "name": "school_classes",
      "macro": "has_many",
      "resource_name": "SchoolClass",
      "through": null
    },
    {
      "className": "SchoolYear",
      "collectionName": "school_years",
      "foreignKey": "school_id",
      "name": "school_years",
      "macro": "has_many",
      "resource_name": "SchoolYear",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "child_id",
      "name": "student_council_contacts",
      "macro": "has_many",
      "resource_name": "Contact",
      "through": "contact"
    },
    {
      "className": "StudentCouncilMembership",
      "collectionName": "student_council_memberships",
      "foreignKey": "organization_id",
      "name": "student_council_memberships",
      "macro": "has_many",
      "resource_name": "StudentCouncilMembership",
      "through": null
    },
    {
      "className": "StudentCouncil",
      "collectionName": "student_councils",
      "foreignKey": "student_council_id",
      "name": "student_councils",
      "macro": "has_many",
      "resource_name": "StudentCouncil",
      "through": "student_council_contacts"
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "TeamSurvey",
      "collectionName": "team_surveys",
      "foreignKey": "team_id",
      "name": "team_surveys",
      "macro": "has_many",
      "resource_name": "TeamSurvey",
      "through": "teams"
    },
    {
      "className": "Team",
      "collectionName": "teams",
      "foreignKey": "team_id",
      "name": "teams",
      "macro": "has_many",
      "resource_name": "Team",
      "through": "school_years"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "UniActiveCode",
      "collectionName": "uni_active_codes",
      "foreignKey": "uni_active_code_id",
      "name": "uni_active_code",
      "macro": "belongs_to",
      "resource_name": "UniActiveCode",
      "through": null
    },
    {
      "className": "Organization",
      "collectionName": "organizations",
      "foreignKey": "uni_overall_institution_id",
      "name": "uni_overall_institution",
      "macro": "belongs_to",
      "resource_name": "Organization",
      "through": null
    },
    {
      "className": "Organization",
      "collectionName": "organizations",
      "foreignKey": "uni_overall_institution_id",
      "name": "uni_overall_institution_for",
      "macro": "has_many",
      "resource_name": "Organization",
      "through": null
    },
    {
      "className": "UniOwnerCode",
      "collectionName": "uni_owner_codes",
      "foreignKey": "uni_owner_code_id",
      "name": "uni_owner_code",
      "macro": "belongs_to",
      "resource_name": "UniOwnerCode",
      "through": null
    },
    {
      "className": "UniTypeThree",
      "collectionName": "uni_type_threes",
      "foreignKey": "uni_type_three_id",
      "name": "uni_type_three",
      "macro": "belongs_to",
      "resource_name": "UniTypeThree",
      "through": null
    },
    {
      "className": "UniTypeTwo",
      "collectionName": "uni_type_twos",
      "foreignKey": "uni_type_two_id",
      "name": "uni_type_two",
      "macro": "belongs_to",
      "resource_name": "UniTypeTwo",
      "through": null
    },
    {
      "className": "UniUnitType",
      "collectionName": "uni_unit_types",
      "foreignKey": "uni_unit_type_id",
      "name": "uni_unit_type",
      "macro": "belongs_to",
      "resource_name": "UniUnitType",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "deleted_at",
      "column": {
        "default": null,
        "name": "deleted_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "deprecated_region_id",
      "column": {
        "default": null,
        "name": "deprecated_region_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "ean_nemhandel_profile",
      "column": {
        "default": null,
        "name": "ean_nemhandel_profile",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "ean_number",
      "column": {
        "default": null,
        "name": "ean_number",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "ean_receiver_identifier",
      "column": {
        "default": null,
        "name": "ean_receiver_identifier",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "grade_from",
      "column": {
        "default": null,
        "name": "grade_from",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "grade_to",
      "column": {
        "default": null,
        "name": "grade_to",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "name",
      "column": {
        "default": null,
        "name": "name",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "nemoa_old_number_of_pupils",
      "column": {
        "default": null,
        "name": "nemoa_old_number_of_pupils",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "number_of_students",
      "column": {
        "default": null,
        "name": "number_of_students",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "organization_type",
      "column": {
        "default": "school",
        "name": "organization_type",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "school_type",
      "column": {
        "default": null,
        "name": "school_type",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "students_count",
      "column": {
        "default": 0,
        "name": "students_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "sync_name_with_uni_c",
      "column": {
        "default": null,
        "name": "sync_name_with_uni_c",
        "null": true,
        "type": "boolean"
      }
    },
    {
      "name": "team_surveys_count",
      "column": {
        "default": 0,
        "name": "team_surveys_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "teams_count",
      "column": {
        "default": 0,
        "name": "teams_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "uni_active_code_id",
      "column": {
        "default": null,
        "name": "uni_active_code_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "uni_c_active_code",
      "column": {
        "default": null,
        "name": "uni_c_active_code",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "uni_c_bel_kommune",
      "column": {
        "default": null,
        "name": "uni_c_bel_kommune",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "uni_c_bel_region",
      "column": {
        "default": null,
        "name": "uni_c_bel_region",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "uni_c_institution_leader",
      "column": {
        "default": null,
        "name": "uni_c_institution_leader",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "uni_c_institution_type_number2",
      "column": {
        "default": null,
        "name": "uni_c_institution_type_number2",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "uni_c_institution_type_number3",
      "column": {
        "default": null,
        "name": "uni_c_institution_type_number3",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "uni_c_kommune_nr",
      "column": {
        "default": null,
        "name": "uni_c_kommune_nr",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "uni_c_latitude",
      "column": {
        "default": null,
        "name": "uni_c_latitude",
        "null": true,
        "type": "float"
      }
    },
    {
      "name": "uni_c_longitude",
      "column": {
        "default": null,
        "name": "uni_c_longitude",
        "null": true,
        "type": "float"
      }
    },
    {
      "name": "uni_c_overall_institutional_code",
      "column": {
        "default": null,
        "name": "uni_c_overall_institutional_code",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "uni_c_owner_number",
      "column": {
        "default": null,
        "name": "uni_c_owner_number",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "uni_c_p_number",
      "column": {
        "default": null,
        "name": "uni_c_p_number",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "uni_c_region_nr",
      "column": {
        "default": null,
        "name": "uni_c_region_nr",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "uni_c_unit_type",
      "column": {
        "default": null,
        "name": "uni_c_unit_type",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "uni_c_vat_number",
      "column": {
        "default": null,
        "name": "uni_c_vat_number",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "uni_id",
      "column": {
        "default": null,
        "name": "uni_id",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "uni_overall_institution_id",
      "column": {
        "default": null,
        "name": "uni_overall_institution_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "uni_owner_code_id",
      "column": {
        "default": null,
        "name": "uni_owner_code_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "uni_type_three_id",
      "column": {
        "default": null,
        "name": "uni_type_three_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "uni_type_two_id",
      "column": {
        "default": null,
        "name": "uni_type_two_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "uni_unit_type_id",
      "column": {
        "default": null,
        "name": "uni_unit_type_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "vat_number",
      "column": {
        "default": null,
        "name": "vat_number",
        "null": true,
        "type": "string"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "not_disabled_active_code"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Organization",
      "collectionName": "organizations",
      "foreignKey": "organization_id",
      "name": "commune",
      "macro": "has_one",
      "resource_name": "Organization",
      "through": "commune_contact"
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "organization_id",
      "name": "contact",
      "macro": "has_one",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "Address",
      "collectionName": "addresses",
      "foreignKey": "address_id",
      "name": "primary_address",
      "macro": "has_one",
      "resource_name": "Address",
      "through": "contact"
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "school_id",
      "name": "school_classes",
      "macro": "has_many",
      "resource_name": "SchoolClass",
      "through": null
    },
    {
      "className": "StudentCouncilMembership",
      "collectionName": "student_council_memberships",
      "foreignKey": "organization_id",
      "name": "student_council_memberships",
      "macro": "has_many",
      "resource_name": "StudentCouncilMembership",
      "through": null
    },
    {
      "className": "Team",
      "collectionName": "teams",
      "foreignKey": "team_id",
      "name": "teams",
      "macro": "has_many",
      "resource_name": "Team",
      "through": "school_years"
    },
    {
      "className": "UniActiveCode",
      "collectionName": "uni_active_codes",
      "foreignKey": "uni_active_code_id",
      "name": "uni_active_code",
      "macro": "belongs_to",
      "resource_name": "UniActiveCode",
      "through": null
    },
    {
      "className": "Organization",
      "collectionName": "organizations",
      "foreignKey": "uni_overall_institution_id",
      "name": "uni_overall_institution",
      "macro": "belongs_to",
      "resource_name": "Organization",
      "through": null
    },
    {
      "className": "UniOwnerCode",
      "collectionName": "uni_owner_codes",
      "foreignKey": "uni_owner_code_id",
      "name": "uni_owner_code",
      "macro": "belongs_to",
      "resource_name": "UniOwnerCode",
      "through": null
    },
    {
      "className": "UniTypeThree",
      "collectionName": "uni_type_threes",
      "foreignKey": "uni_type_three_id",
      "name": "uni_type_three",
      "macro": "belongs_to",
      "resource_name": "UniTypeThree",
      "through": null
    },
    {
      "className": "UniTypeTwo",
      "collectionName": "uni_type_twos",
      "foreignKey": "uni_type_two_id",
      "name": "uni_type_two",
      "macro": "belongs_to",
      "resource_name": "UniTypeTwo",
      "through": null
    },
    {
      "className": "UniUnitType",
      "collectionName": "uni_unit_types",
      "foreignKey": "uni_unit_type_id",
      "name": "uni_unit_type",
      "macro": "belongs_to",
      "resource_name": "UniUnitType",
      "through": null
    }
  ],
  "paramKey": "organization",
  "primaryKey": "id"
}

/** Frontend model for Organization. */
export default class Organization extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  deletedAt() {
    return this.readAttributeUnderscore("deleted_at")
  }

  /** @returns {boolean} */
  hasDeletedAt() {
    const value = this.deletedAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  eanNemhandelProfile() {
    return this.readAttributeUnderscore("ean_nemhandel_profile")
  }

  /** @returns {boolean} */
  hasEanNemhandelProfile() {
    const value = this.eanNemhandelProfile()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  eanNumber() {
    return this.readAttributeUnderscore("ean_number")
  }

  /** @returns {boolean} */
  hasEanNumber() {
    const value = this.eanNumber()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  eanReceiverIdentifier() {
    return this.readAttributeUnderscore("ean_receiver_identifier")
  }

  /** @returns {boolean} */
  hasEanReceiverIdentifier() {
    const value = this.eanReceiverIdentifier()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  gradeFrom() {
    return this.readAttributeUnderscore("grade_from")
  }

  /** @returns {boolean} */
  hasGradeFrom() {
    const value = this.gradeFrom()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  gradeTo() {
    return this.readAttributeUnderscore("grade_to")
  }

  /** @returns {boolean} */
  hasGradeTo() {
    const value = this.gradeTo()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  numberOfStudents() {
    return this.readAttributeUnderscore("number_of_students")
  }

  /** @returns {boolean} */
  hasNumberOfStudents() {
    const value = this.numberOfStudents()

    return this._isPresent(value)
  }

  /** @returns {string} */
  organizationType() {
    return this.readAttributeUnderscore("organization_type")
  }

  /** @returns {boolean} */
  hasOrganizationType() {
    const value = this.organizationType()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  schoolType() {
    return this.readAttributeUnderscore("school_type")
  }

  /** @returns {boolean} */
  hasSchoolType() {
    const value = this.schoolType()

    return this._isPresent(value)
  }

  /** @returns {boolean | null} */
  syncNameWithUniC() {
    return this.readAttributeUnderscore("sync_name_with_uni_c")
  }

  /** @returns {boolean} */
  hasSyncNameWithUniC() {
    const value = this.syncNameWithUniC()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  vatNumber() {
    return this.readAttributeUnderscore("vat_number")
  }

  /** @returns {boolean} */
  hasVatNumber() {
    const value = this.vatNumber()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  nemoaOldNumberOfPupils() {
    return this.readAttributeUnderscore("nemoa_old_number_of_pupils")
  }

  /** @returns {boolean} */
  hasNemoaOldNumberOfPupils() {
    const value = this.nemoaOldNumberOfPupils()

    return this._isPresent(value)
  }

  /** @returns {number} */
  studentsCount() {
    return this.readAttributeUnderscore("students_count")
  }

  /** @returns {boolean} */
  hasStudentsCount() {
    const value = this.studentsCount()

    return this._isPresent(value)
  }

  /** @returns {number} */
  teamsCount() {
    return this.readAttributeUnderscore("teams_count")
  }

  /** @returns {boolean} */
  hasTeamsCount() {
    const value = this.teamsCount()

    return this._isPresent(value)
  }

  /** @returns {number} */
  teamSurveysCount() {
    return this.readAttributeUnderscore("team_surveys_count")
  }

  /** @returns {boolean} */
  hasTeamSurveysCount() {
    const value = this.teamSurveysCount()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  uniCActiveCode() {
    return this.readAttributeUnderscore("uni_c_active_code")
  }

  /** @returns {boolean} */
  hasUniCActiveCode() {
    const value = this.uniCActiveCode()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  uniCOverallInstitutionalCode() {
    return this.readAttributeUnderscore("uni_c_overall_institutional_code")
  }

  /** @returns {boolean} */
  hasUniCOverallInstitutionalCode() {
    const value = this.uniCOverallInstitutionalCode()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  uniCUnitType() {
    return this.readAttributeUnderscore("uni_c_unit_type")
  }

  /** @returns {boolean} */
  hasUniCUnitType() {
    const value = this.uniCUnitType()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  uniCInstitutionTypeNumber2() {
    return this.readAttributeUnderscore("uni_c_institution_type_number2")
  }

  /** @returns {boolean} */
  hasUniCInstitutionTypeNumber2() {
    const value = this.uniCInstitutionTypeNumber2()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  uniCInstitutionTypeNumber3() {
    return this.readAttributeUnderscore("uni_c_institution_type_number3")
  }

  /** @returns {boolean} */
  hasUniCInstitutionTypeNumber3() {
    const value = this.uniCInstitutionTypeNumber3()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  uniCInstitutionLeader() {
    return this.readAttributeUnderscore("uni_c_institution_leader")
  }

  /** @returns {boolean} */
  hasUniCInstitutionLeader() {
    const value = this.uniCInstitutionLeader()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  uniCVatNumber() {
    return this.readAttributeUnderscore("uni_c_vat_number")
  }

  /** @returns {boolean} */
  hasUniCVatNumber() {
    const value = this.uniCVatNumber()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  uniCPNumber() {
    return this.readAttributeUnderscore("uni_c_p_number")
  }

  /** @returns {boolean} */
  hasUniCPNumber() {
    const value = this.uniCPNumber()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  uniCOwnerNumber() {
    return this.readAttributeUnderscore("uni_c_owner_number")
  }

  /** @returns {boolean} */
  hasUniCOwnerNumber() {
    const value = this.uniCOwnerNumber()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  uniCLatitude() {
    return this.readAttributeUnderscore("uni_c_latitude")
  }

  /** @returns {boolean} */
  hasUniCLatitude() {
    const value = this.uniCLatitude()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  uniCLongitude() {
    return this.readAttributeUnderscore("uni_c_longitude")
  }

  /** @returns {boolean} */
  hasUniCLongitude() {
    const value = this.uniCLongitude()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  uniId() {
    return this.readAttributeUnderscore("uni_id")
  }

  /** @returns {boolean} */
  hasUniId() {
    const value = this.uniId()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedOrganizationType() {
    return this.readAttributeUnderscore("translated_organization_type")
  }

  /** @returns {boolean} */
  hasTranslatedOrganizationType() {
    const value = this.translatedOrganizationType()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static adminCreate(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "admin_create",
        collectionName: "organizations",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static classesForSchool(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "classes_for_school",
        collectionName: "organizations",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static updateNumberOfStudentsFromCsv(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "update_number_of_students_from_csv",
        collectionName: "organizations",
        type: "collection"
      },
      commandArgs
    ))
  }

  /** @returns {import("./organization.js").default | null} */
  commune() {
    return this._readHasOneReflection({modelClass: Organization, reflectionName: "commune"})
  }

  /** @returns {Promise<import("./organization.js").default | null>} */
  loadCommune() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()

    return this._loadHasOneReflection(
      {
        reflectionName: "commune",
        model: this,
        modelClass: Organization
      },
      {
        params: {
          through: {
            model: "Organization",
            id,
            reflection: "commune"
          }
        }
      }
    )
  }

  /** @returns {Promise<import("./organization.js").default | null>} */
  ensureCommuneLoaded() {
    return this.ensureAssociationLoaded("commune")
  }

  /** @returns {import("./contact.js").default | null} */
  contact() {
    return this._readHasOneReflection({modelClass: Contact, reflectionName: "contact"})
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  loadContact() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["organization_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "contact",
        model: this,
        modelClass: Contact
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  ensureContactLoaded() {
    return this.ensureAssociationLoaded("contact")
  }

  /** @returns {import("./address.js").default | null} */
  primaryAddress() {
    return this._readHasOneReflection({modelClass: Address, reflectionName: "primary_address"})
  }

  /** @returns {Promise<import("./address.js").default | null>} */
  loadPrimaryAddress() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()

    return this._loadHasOneReflection(
      {
        reflectionName: "primary_address",
        model: this,
        modelClass: Address
      },
      {
        params: {
          through: {
            model: "Organization",
            id,
            reflection: "primary_address"
          }
        }
      }
    )
  }

  /** @returns {Promise<import("./address.js").default | null>} */
  ensurePrimaryAddressLoaded() {
    return this.ensureAssociationLoaded("primary_address")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./school-class.js").default>} */
  schoolClasses() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["school_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "school_classes",
        model: this,
        modelClass: SchoolClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./school-class.js").default>>} */
  loadSchoolClasses() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["school_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "school_classes",
        model: this,
        modelClass: SchoolClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./school-class.js").default>>} */
  ensureSchoolClassesLoaded() {
    return this.ensureAssociationLoaded("school_classes")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./student-council-membership.js").default>} */
  studentCouncilMemberships() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["organization_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "student_council_memberships",
        model: this,
        modelClass: StudentCouncilMembership
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./student-council-membership.js").default>>} */
  loadStudentCouncilMemberships() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["organization_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "student_council_memberships",
        model: this,
        modelClass: StudentCouncilMembership
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./student-council-membership.js").default>>} */
  ensureStudentCouncilMembershipsLoaded() {
    return this.ensureAssociationLoaded("student_council_memberships")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./team.js").default>} */
  teams() {
    return new Collection(
      {
        reflectionName: "teams",
        model: this,
        modelClass: Team
      },
      {
        params: {
          through: {
            model: "Organization",
            id: this.primaryKey(),
            reflection: "teams"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./team.js").default>>} */
  loadTeams() {
    return this._loadHasManyReflection(
      {
        reflectionName: "teams",
        model: this,
        modelClass: Team
      },
      {
        params: {
          through: {
            model: "Organization",
            id: this.primaryKey(),
            reflection: "teams"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./team.js").default>>} */
  ensureTeamsLoaded() {
    return this.ensureAssociationLoaded("teams")
  }

  /** @returns {import("./uni-active-code.js").default | null} */
  uniActiveCode() {
    return this._readBelongsToReflection({modelClass: UniActiveCode, reflectionName: "uni_active_code"})
  }

  /** @returns {Promise<import("./uni-active-code.js").default | null>} */
  loadUniActiveCode() {
    if (!("uniActiveCodeId" in this)) throw new Error("Foreign key method wasn't defined: uniActiveCodeId")

    const id = this.uniActiveCodeId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "uni_active_code",
        model: this,
        modelClass: UniActiveCode
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./uni-active-code.js").default | null>} */
  ensureUniActiveCodeLoaded() {
    return this.ensureAssociationLoaded("uni_active_code")
  }

  /** @returns {import("./organization.js").default | null} */
  uniOverallInstitution() {
    return this._readBelongsToReflection({modelClass: Organization, reflectionName: "uni_overall_institution"})
  }

  /** @returns {Promise<import("./organization.js").default | null>} */
  loadUniOverallInstitution() {
    if (!("uniOverallInstitutionId" in this)) throw new Error("Foreign key method wasn't defined: uniOverallInstitutionId")

    const id = this.uniOverallInstitutionId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "uni_overall_institution",
        model: this,
        modelClass: Organization
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./organization.js").default | null>} */
  ensureUniOverallInstitutionLoaded() {
    return this.ensureAssociationLoaded("uni_overall_institution")
  }

  /** @returns {import("./uni-owner-code.js").default | null} */
  uniOwnerCode() {
    return this._readBelongsToReflection({modelClass: UniOwnerCode, reflectionName: "uni_owner_code"})
  }

  /** @returns {Promise<import("./uni-owner-code.js").default | null>} */
  loadUniOwnerCode() {
    if (!("uniOwnerCodeId" in this)) throw new Error("Foreign key method wasn't defined: uniOwnerCodeId")

    const id = this.uniOwnerCodeId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "uni_owner_code",
        model: this,
        modelClass: UniOwnerCode
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./uni-owner-code.js").default | null>} */
  ensureUniOwnerCodeLoaded() {
    return this.ensureAssociationLoaded("uni_owner_code")
  }

  /** @returns {import("./uni-type-three.js").default | null} */
  uniTypeThree() {
    return this._readBelongsToReflection({modelClass: UniTypeThree, reflectionName: "uni_type_three"})
  }

  /** @returns {Promise<import("./uni-type-three.js").default | null>} */
  loadUniTypeThree() {
    if (!("uniTypeThreeId" in this)) throw new Error("Foreign key method wasn't defined: uniTypeThreeId")

    const id = this.uniTypeThreeId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "uni_type_three",
        model: this,
        modelClass: UniTypeThree
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./uni-type-three.js").default | null>} */
  ensureUniTypeThreeLoaded() {
    return this.ensureAssociationLoaded("uni_type_three")
  }

  /** @returns {import("./uni-type-two.js").default | null} */
  uniTypeTwo() {
    return this._readBelongsToReflection({modelClass: UniTypeTwo, reflectionName: "uni_type_two"})
  }

  /** @returns {Promise<import("./uni-type-two.js").default | null>} */
  loadUniTypeTwo() {
    if (!("uniTypeTwoId" in this)) throw new Error("Foreign key method wasn't defined: uniTypeTwoId")

    const id = this.uniTypeTwoId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "uni_type_two",
        model: this,
        modelClass: UniTypeTwo
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./uni-type-two.js").default | null>} */
  ensureUniTypeTwoLoaded() {
    return this.ensureAssociationLoaded("uni_type_two")
  }

  /** @returns {import("./uni-unit-type.js").default | null} */
  uniUnitType() {
    return this._readBelongsToReflection({modelClass: UniUnitType, reflectionName: "uni_unit_type"})
  }

  /** @returns {Promise<import("./uni-unit-type.js").default | null>} */
  loadUniUnitType() {
    if (!("uniUnitTypeId" in this)) throw new Error("Foreign key method wasn't defined: uniUnitTypeId")

    const id = this.uniUnitTypeId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "uni_unit_type",
        model: this,
        modelClass: UniUnitType
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./uni-unit-type.js").default | null>} */
  ensureUniUnitTypeLoaded() {
    return this.ensureAssociationLoaded("uni_unit_type")
  }
}
